import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getIntakeCoordinatesList as getIntakeCoordinatesListApi,
	getIntakeCoordinatesListQuery as getIntakeCoordinatesListQueryApi,
	getIntakeCoordinatesItem as getIntakeCoordinatesItemApi,
	addNewIntakeCoordinatesApi,
	updateIntakeCoordinatesApi,
	deleteIntakeCoordinatesApi,
} from '../../helpers/intake_coordinates/api_helper';

export const getIntakeCoordinatesList = createAsyncThunk(
	'intakeCoordinates/getIntakeCoordinatesList',
	async (params = {}) => {
		try {
			const response = await getIntakeCoordinatesListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las coordenadas de captación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getIntakeCoordinatesListQuery = createAsyncThunk(
	'intakeCoordinates/getIntakeCoordinatesListQuery',
	async params => {
		try {
			const response = getIntakeCoordinatesListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getIntakeCoordinatesItem = createAsyncThunk(
	'intakeCoordinates/getIntakeCoordinatesItem',
	async ({ id, populate = [] }) => {
		try {
			const response = await getIntakeCoordinatesItemApi(id, populate);
			return response;
		} catch (error) {
			toast.error('Error al obtener la coordenada de captación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewIntakeCoordinates = createAsyncThunk(
	'intakeCoordinates/addNewIntakeCoordinates',
	async intake_coordinates => {
		try {
			const response = await addNewIntakeCoordinatesApi(intake_coordinates);
			const data = response.data || response;
			
			toast.success('Coordenada de captación agregada exitosamente.', {
				autoClose: 3000,
			});
			return data;
		} catch (error) {
			toast.error('Error al agregar la coordenada de captación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateIntakeCoordinates = createAsyncThunk(
	'intakeCoordinates/updateIntakeCoordinates',
	async intake_coordinates => {
		try {
			const response = await updateIntakeCoordinatesApi(intake_coordinates);
			const data = response.data || response;
			
			toast.success('Coordenada de captación actualizada exitosamente.', {
				autoClose: 3000,
			});
			return data;
		} catch (error) {
			toast.error('Error al actualizar la coordenada de captación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteIntakeCoordinates = createAsyncThunk(
	'intakeCoordinates/deleteIntakeCoordinates',
	async intake_coordinates => {
		try {
			const response = await deleteIntakeCoordinatesApi(intake_coordinates._id);
			toast.success('Coordenada de captación eliminada exitosamente.', {
				autoClose: 3000,
			});
			return intake_coordinates;
		} catch (error) {
			toast.error('Error al eliminar la coordenada de captación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
